import { useState } from "react";
import MySubjects from '../../components/ui/MySubject';
import ManageSubjects from '../../components/ui/ManageSubjects';
import SubjectTabs from "../../components/common/SubjectTabs";

const SubjectPage = () => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <>
      <div className="min-h-[calc(100%-theme(space.2))] bg-myLight pb-4">
        <section className="border-b border-myInputBorder/60 bg-transparent backdrop-blur-md w-full sticky z-30 top-0 p-4">
          <div className="max-w-5xl mx-auto px-4">
            <h1 className="md:text-2xl sm:text-xl lext-lg font-bold text-myLabelText capitalize">
              Subject details
            </h1>
          </div>
        </section>
        <section className="max-w-5xl mx-auto px-4 ">
          <SubjectTabs
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            tabs={[
              {
                label: "My Subject",
                content: <MySubjects />
              },
              {
                label: "Add Subject",
                content: <ManageSubjects onEnrollSuccess={() => setActiveTab(0)} />
              },
            ]}
          />
        </section>
      </div>
    </>
  );
};

export default SubjectPage;
